import "./Navbar.css";
import { NavLink } from "react-router-dom";
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useEffect } from "react";



function Navbar() {
  const [search, setSearch] = useState("");
  const [open, setOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 870);
  const navigate = useNavigate();
  const handleHamburger = () => setOpen((prev) => !prev);

  // Hide navbar on scroll down, show on scroll up
  useEffect(() => {
    let lastScrollY = window.scrollY;
    const navbar = document.querySelector('.navbar-container');
    if (!navbar) return;
    function onScroll() {
      if (window.scrollY > lastScrollY && window.scrollY > 50) {
        navbar.classList.add('navbar-hide');
      } else {
        navbar.classList.remove('navbar-hide');
      }
      lastScrollY = window.scrollY;
    }
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  useEffect(() => {
    if (!open || !isMobile) return;
    function handleClick(e) {
      const menu = document.querySelector('.navbar-links');
      if (menu && !menu.contains(e.target)) setOpen(false);
    }
    function handleEsc(e) {
      if (e.key === 'Escape') setOpen(false);
    }
    document.addEventListener('mousedown', handleClick);
    document.addEventListener('touchstart', handleClick);
    document.addEventListener('keydown', handleEsc);
    return () => {
      document.removeEventListener('mousedown', handleClick);
      document.removeEventListener('touchstart', handleClick);
      document.removeEventListener('keydown', handleEsc);
    };
  }, [open, isMobile]);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 870);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  
  return (
    <nav className="navbar-container">
      <button className="hamburger" onClick={handleHamburger} aria-label="Toggle navigation">
        <span></span>
        <span></span>
        <span></span>
      </button>
      {open && isMobile && (
        <div
          className="navbar-overlay"
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100vw",
            height: "100vh",
            background: "rgba(0,0,0,0.15)",
            zIndex: 9998,
          }}
          onClick={() => setOpen(false)}
        />
      )}
      <div
        className={`navbar-links${open ? " active" : ""}`}
        onClick={e => {
          // Only close if click is on the background, not on a link
          if (e.target.classList.contains("navbar-links")) setOpen(false);
        }}
      >
        {isMobile && (
          <div className="navbar-search-container">
            <input
              type="text"
              className="navbar-search-input"
              placeholder="Keresés..."
              value={search}
              onChange={e => setSearch(e.target.value)}
              onKeyDown={e => {
                if (e.key === "Enter") {
                  e.preventDefault();
                  if (window.location.pathname === "/search") {
                    window.location.href = `/search?q=${encodeURIComponent(search)}`;
                  } else {
                    navigate(`/search?q=${encodeURIComponent(search)}`);
                  }
                  setOpen(false);
                }
              }}
            />
            {/* Mobil nézetben ne jelenjen meg találatjavaslat */}
          </div>
        )}
  <NavLink className="nav-link" to="/">Kezdőlap</NavLink>
  {isMobile ? (
    <>
      <NavLink className="nav-link" to="/columns">Rovatok</NavLink>
      <ul className="nav-dropdown-menu nav-dropdown-mobile">
        <li>
          <NavLink className="nav-dropdown-item" to="/columns#interview">Interjú</NavLink>
        </li>
        <li>
          <NavLink className="nav-dropdown-item" to="/columns#recommender">Ajánló</NavLink>
        </li>
        <li>
          <NavLink className="nav-dropdown-item" to="/columns#10">10</NavLink>
        </li>
        <li>
          <NavLink className="nav-dropdown-item" to="/columns#travel_diary">Útinapló</NavLink>
        </li>
        <li>
          <NavLink className="nav-dropdown-item nav-dropdown-item-last" to="/columns#review">Szemle</NavLink>
        </li>
      </ul>
    </>
  ) : (
    <ul className="nav-item dropdown">
      <NavLink className="nav-link dropdown-toggle" to="/columns" role="button">
        Rovatok
      </NavLink>
      <ul className="nav-dropdown-menu" aria-labelledby="navbarDropdown">
        <li>
          <NavLink className="nav-dropdown-item" to="/columns#interview">Interjú</NavLink>
        </li>
        <li>
          <NavLink className="nav-dropdown-item" to="/columns#recommender">Ajánló</NavLink>
        </li>
        <li>
          <NavLink className="nav-dropdown-item" to="/columns#10">10</NavLink>
        </li>
        <li>
          <NavLink className="nav-dropdown-item" to="/columns#travel_diary">Útinapló</NavLink>
        </li>
        <li>
          <NavLink className="nav-dropdown-item" to="/columns#review">Szemle</NavLink>
        </li>
      </ul>
    </ul>
  )}
  <NavLink className="nav-link nav-about" to="/about">Rólunk</NavLink>
  <NavLink className="nav-link" to="/support">Támogatás</NavLink>
  <NavLink className="nav-link" to="/contact">Kapcsolat</NavLink>
  {!isMobile && (
    <NavLink className="nav-link" to="/search" end>Keresés</NavLink>
  )}
  {isMobile && (
    <div style={{ width: '100%', display: 'flex', justifyContent: 'center', margin: '24px 0 0 0' }}>
      <img className ="navbar-logo-bottom"src="/images/logo.webp" alt="Kútonline logó"  />
    </div>
  )}
      </div>
    </nav>
  );

}

export default Navbar;